import { render } from "./AfricaMap.vue?vue&type=template&id=2b33e3ca&scoped=true"
import script from "./AfricaMap.vue?vue&type=script&lang=js"
export * from "./AfricaMap.vue?vue&type=script&lang=js"

import "./AfricaMap.vue?vue&type=style&index=0&id=2b33e3ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b33e3ca"]])

export default __exports__